module.exports = __webpack_public_path__ + "static/integra-blog2-48c9424b20f1de2d1580efffa3a8cd5c.png";